<template>
  <v-card>
    <v-card-title>
      <h2 class="modal-title">{{ $t('base.add_mixer') }}</h2>
    </v-card-title>
    <v-card-content>
      <v-text-field :label="$t('base.mixer_name')" :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')" v-model="form.name" />
    </v-card-content>
    <v-card-actions>
      <v-btn :disabled="!form.name" @click="onCreate" :loading="loading">
        {{ $t('base.add') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'AddMixerModal',

  data: () => ({
    form: {
      name: null
    },
    errors: {
      name: null
    },
    loading: false
  }),

  mixins: [formErrorsMixin],

  methods: {
    async onCreate () {
      this.loading = true

      this.checkValidData()

      if (this.errors.name === null) {
        const mixerData = {
          name: this.form.name
        }
        this.$emit('update', mixerData)
        this.$emit('close')
      }

      this.loading = false
    },

    checkValidData () {
      this.errors.name = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>